import { useState, useMemo, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { isEqual } from 'lodash'

import { getActivityView } from '../../../../../../data/dataServices'
import { getSelectedProject, getViewClientFilters } from '../../../../../../data/dataHelpers'
import { propSatisfies } from 'ramda'

export function useActivityViewQuery(props) {
	const { tile } = props
	const { environment } = useSelector((state) => state)

	const [viewData, setViewData] = useState(null)
	const [allColumns, setAllColumns] = useState([])
	const [serverFilter, setServerFilter] = useState({})

	const {
		data,
		isLoading: viewLoading,
		refetch: reloadActivityView,
	} = useQuery({
		queryKey: ['acitivityView', tile?.key],
		queryFn: () => getActivityView(environment?.apiToken),
		enabled: !!tile?.key,
	})

	useEffect(() => {
		if (viewLoading) return
		const viewData = data?.data
		setViewData(viewData)
		if (!isEqual(allColumns, viewData?.columns)) {
			setAllColumns(viewData?.columns)
		}

		const clientFilter = viewData?.clientFilter ? JSON.parse(viewData?.clientFilter) : undefined

		const currentFiltersWithUserFilter = getViewClientFilters(
			clientFilter,
			environment?.userCurrent?.dataGroupKey
		)
		if (!isEqual(serverFilter, currentFiltersWithUserFilter)) {
			setServerFilter(currentFiltersWithUserFilter)
		}
	}, [viewLoading, data])

	return {
		viewData,
		allColumns,
		serverFilter,
		viewLoading,
		reloadActivityView,
	}
}
